import Close from '@mui/icons-material/Close'
import { Box, Divider, Grid } from '@mui/material'
import {
  Button,
  Card,
  CardHeader,
  Form,
  IconButton,
  Modal,
  ResetButton,
  ResetFilters,
  SelectC
} from 'components'
import { useAuth } from 'lib/auth'
import { SelectSeller } from 'modules/customers/components'
import {
  useLoadCustomerCities,
  useLoadCustomerStates
} from 'modules/customers/hooks'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { MdFilterList } from 'react-icons/md'
import { existsFilters, Yup } from 'utils'
import { useCustomerListContext } from '../context/customerList.context'

type FormValues = {
  state: { id: number; name: string; initials: string } | null
  city: { id: string; name: string } | null
  seller: {
    id: string
    name: string
  } | null
}

const schema = Yup.object({
  state: Yup.object({
    id: Yup.string().required(),
    label: Yup.string(),
    initials: Yup.string()
  }).nullable(),
  city: Yup.object({
    id: Yup.string().required(),
    label: Yup.string()
  }).nullable(),
  seller: Yup.object({
    id: Yup.string().required()
  }).required()
})

const defaultValues = {
  state: null,
  city: null,
  seller: null
}

const FilterListCustomerProvided = () => {
  const { showCustomerFilter, setShowCustomerFilter, filters, setFilters } =
    useCustomerListContext()

  const { watch, setValue } = useFormContext()

  const { user } = useAuth()

  const selectedState = watch('state')

  const { data: states, isLoading: loadingStates } = useLoadCustomerStates({})
  const { data: cities, isLoading: loadingCities } = useLoadCustomerCities({
    stateId: selectedState?.id || ''
  })

  useEffect(() => {
    setValue('city', null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState])

  useEffect(() => {
    setFilters({
      sellerId: user?.companyId
    })
  }, [user, setFilters])

  return (
    <div>
      <>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Button
            sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
            variant="text"
            startIcon={<MdFilterList size={18} />}
            onClick={() => setShowCustomerFilter(true)}
          >
            Filtros
          </Button>
          <IconButton
            sx={{ display: { md: 'none' } }}
            onClick={() => setShowCustomerFilter(true)}
          >
            <MdFilterList size={24} color="#023770" />
          </IconButton>
          {existsFilters(filters) && (
            <ResetFilters
              onClick={() => {
                setFilters({
                  sellerId: user?.companyId
                })
                setValue('seller', {
                  id: user?.companyId || '',
                  name: user?.fullName || ''
                })
              }}
            />
          )}
        </Box>
        <Modal
          open={showCustomerFilter}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
          onClose={() => setShowCustomerFilter(false)}
        >
          <Card
            sx={{
              width: { xs: 300, sm: 400 },
              padding: { xs: 0 }
            }}
          >
            <CardHeader
              title="Filtros"
              HeaderRight={
                <IconButton onClick={() => setShowCustomerFilter(false)}>
                  <Close />
                </IconButton>
              }
            />
            <Divider sx={{ marginBottom: 1 }} />
            <Grid container spacing={2} p={2}>
              <Grid item xs={12}>
                <SelectSeller />
              </Grid>
              <Grid item xs={12}>
                <SelectC
                  name="state"
                  options={states?.data}
                  loading={loadingStates}
                  label="Estado"
                  getOptionLabel={(option: any) => option?.name}
                />
              </Grid>
              <Grid item xs={12}>
                <SelectC
                  name="city"
                  options={cities?.data}
                  loading={loadingCities}
                  label="Município"
                  disabled={!watch('state')}
                  getOptionLabel={(option: any) => option?.name}
                />
              </Grid>
              {user?.role === 'A' && (
                <Grid item xs={12}>
                  <SelectSeller />
                </Grid>
              )}
            </Grid>
            <Divider sx={{ marginTop: 1 }} />
            <Grid
              container
              item
              alignItems="center"
              justifyContent="space-between"
              xs={12}
              p={2}
            >
              <ResetButton
                onClick={() => {
                  setFilters({
                    sellerId: user?.companyId
                  })
                  setValue('seller', {
                    id: user?.companyId || '',
                    name: user?.fullName || ''
                  })
                }}
              />
              <Button
                form="customer-table-filter-form"
                type="submit"
                variant="contained"
              >
                Aplicar
              </Button>
            </Grid>
          </Card>
        </Modal>
      </>
    </div>
  )
}

export const FilterListCustomer = () => {
  const { setShowCustomerFilter, setFilters } = useCustomerListContext()

  const handleSubmit = (data: FormValues) => {
    setFilters({
      sellerId: data?.seller?.id,
      cityName: data?.city?.name,
      stateId: data?.state?.id
    })
    setShowCustomerFilter(false)
  }
  return (
    <Form<FormValues>
      id="customer-table-filter-form"
      onSubmit={handleSubmit}
      schema={schema}
      options={{ defaultValues }}
    >
      <FilterListCustomerProvided />
    </Form>
  )
}
